import { useMutation } from "react-query";
import { POST } from "../../../../Services";
import { notification } from "antd";

export const useEliminarGachapon = () => {
  return useMutation(
    async (data) => await POST(data, "gachapon/eliminarGachapon"),
    {
      onSuccess: () => {
        notification.success({
          message: "Gachapon eliminado",
          description: "El gachapon se ha eliminado correctamente",
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification.error({ 
            message: "Error al eliminar",
            description: error.response.data.datos 
          });
        } else {
          notification.error({ 
            message: "Error al eliminar",
            description: "Error al intentar eliminar el gachapon" 
          });
        }
      },
    }
  );
};
